// @flow

// Mapper
import mapperFastTrackAncillary from "./mapperFastTrackAncillary"
// Types
import type {
  AncillariesInput,
  Ancillaries,
} from "mmb/scenes/AccountBooking/components/Booking/scenes/BookingAncillary/consts/types"
import mapperSeatingAncillary from "./mapperSeatingAncillary"

export default function(ancillaries: AncillariesInput): Ancillaries {
  return {
    fastTrack: ancillaries.fast_track && mapperFastTrackAncillary(ancillaries.fast_track),
    seating: mapperSeatingAncillary(ancillaries.seating),
  }
}
